<template>
  <div class="queryResult" v-if="isLoading">
    <div class="addExperiment-title">
      <span @click="goRouter('/experimentList')">实验列表&nbsp;&nbsp; / &nbsp;&nbsp;</span>
      <i>查看成绩</i>
    </div>
    <div class="result-container">
      <div class="tabs-list">
        <div class="list" @click="toggleTab(0)" :class="active == 0 ? 'result-active-tabs' : ''">
          全部学生
        </div>
        <div class="list" @click="toggleTab(1)" :class="active == 1 ? 'result-active-tabs' : ''">
          必修学生
        </div>
        <div class="list" @click="toggleTab(2)" :class="active == 2 ? 'result-active-tabs' : ''">
          选修学生
        </div>
      </div>
      <div class="btnList">
        <el-input placeholder="请输入学生姓名/学号" v-model="searchInput" @blur="search" @keyup.native.enter="search">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <div class="btn1" @click="exportScore">导出成绩</div>
        <div class="btn2" @click="dialogTableVisible = true">成绩统计</div>
        <div class="btn3" @click="goRouter('/experimentList')">返回</div>
      </div>
    </div>
    <div class="content-tables">
      <!-- <el-table :data="scoreList" style="width: 100%">
        <el-table-column :selectable="checkboxInit">
          <template slot="header">
            <el-checkbox
              v-model="checkAll"
              :indeterminate="checkAll"
              @change="checkAllScoreList"
              >学校</el-checkbox
            >
          </template>
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.isChioce"
              @change="checkScore(scope.row)"
              >{{ scope.row.schoolName }}</el-checkbox
            >
          </template>
        </el-table-column>
        <el-table-column prop="licenseNo" label="学号"></el-table-column>
        <el-table-column prop="name" label="名字"></el-table-column>
        <el-table-column prop="score" label="成绩"></el-table-column>
        <el-table-column label="交卷时间">
          <template slot-scope="scope">
            {{ getTime(scope.row.createDate) }}
          </template>
        </el-table-column>
        <el-table-column label="必修/选修">
          <template slot-scope="scope">
            <span v-if="scope.row.obligatory == 1">必修</span>
            <span v-if="scope.row.obligatory == 2">选修</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="是否有报告"></el-table-column>
        <el-table-column width="200">
          <template slot="header">
            <span class="fontSizeCenter">操作</span>
          </template>
          <p class="operation"><span>预览</span><i>|</i><span>下载</span></p>
        </el-table-column>
      </el-table> -->
      <Table ref="selection" :columns="columns" :data="scoreList">
        <template slot-scope="{ row }" slot="schoolName">
          <strong>{{ row.schoolName }}</strong>
        </template>
        <template slot-scope="{ row }" slot="name">
          <strong v-if="row.schoolId != 0">{{ row.name }}</strong>
          <strong v-else>游客</strong>
        </template>
        <template slot-scope="{ row }" slot="createDate">
          <strong>{{ getTime(row.createDate) }}</strong>
        </template>
        <template slot-scope="{ row }" slot="obligatory">
          <span v-if="row.obligatory == 1">必修</span>
          <span v-if="row.obligatory == 2">选修</span>
        </template>
        <template slot-scope="{ row }" slot="operation">
          <span class="operation" @click="queryReport(row)">查看报告</span>
          <!-- <a :href="row.url" target="_blank" :download="row.licenseNo+row.name+'.pdf'">查看报告</a> -->
        </template>

      </Table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4"
        :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems">
      </el-pagination>
    </div>
    <el-dialog title="成绩统计" :visible.sync="dialogTableVisible" width="70%">
      <div class="scoreStatistics" v-if="scoreStatisticsList != null && hasAllScore()">
        <div v-for="(item, index) in scoreStatisticsList" :key="index"
          :style="hasScore(item) ? 'display:block' : 'display:none'">
          <scorePicture v-if="hasScore(item)" :detail="item" :title="index"></scorePicture>
        </div>
      </div>
      <div v-else><el-empty description="暂无成绩"></el-empty></div>
    </el-dialog>
    <el-dialog title="报告详情" :visible.sync="isShowReport" width="70%">
      <!-- <iframe width="100%" height="600px" border=0 frameborder="no" :src="reportUrl"></iframe> -->
      <div class="iframe-content">
        <iframe width="100%" height="600px" border=0 frameborder="no" :id="officeId" :src="reportUrl"></iframe>
        <!-- <object :data="reportUrl" type="application/pdf" width="100%" height="600px"></object> -->
        <!-- <div class="btn1" @click="onDownload">下载报告</div> -->
        <el-button type="primary" size="small" class="downloadBtn" @click="onDownload">下载报告</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import scorePicture from "@/components/scorePicture.vue";
import util from "@/assets/util/util.js";
export default {
  name: "VirtualimitationQueryresults",
  components: {
    scorePicture,
  },
  data() {
    return {
      active: 0,
      searchInput: "",
      currentPage4: 1,
      scoreList: [],
      totalItems: 0,
      params: {
        experimentId: 0, //实验id
        obligatory: 0, //0 全部 1 必修 2 选修
        name: "",
        pageIndex: 1,
        schoolId: 0,
        showItem: 10,
      },
      isLoading: false,
      dialogTableVisible: false,
      checkAll: false,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "学校",
          key: "schoolName",
          slot: "schoolName",
        },
        {
          title: "学号",
          key: "licenseNo",
        },
        {
          title: "名字",
          key: "name",
          slot: "name",
        },
        {
          title: "成绩",
          key: "score",
        },
        {
          title: "交卷时间",
          key: "createDate",
          slot: "createDate",
        },
        {
          title: "必须/选修",
          key: "obligatory",
          slot: "obligatory",
        },
        {
          title: "操作",
          key: "operation",
          slot: "operation",
        },
      ],
      scoreStatisticsList: null,
      reportUrl: "",
      curUrl: "",
      isShowReport: false,
      officeId: process.env.VUE_APP_IFRAME,
    };
  },

  mounted() {
    this.getExperimentReport(0);
    this.getExperimentScoreStatics();
  },

  methods: {
    onDownload() {
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.href =
        this.curUrl +
        "?response-content-type=application/octet-stream";
      a.click();
      document.body.removeChild(a);
    },
    // 查看报告
    queryReport(row) {
      if (!row.url) {
        this.$message({
          message: "当前学生暂无报告！",
          type: "warning",
        });
        return;
      }
      this.curUrl = row.url;
      this.reportUrl = `https://ow365.cn/?i=${this.officeId}&ssl=1&furl=${row.url}`;
      this.isShowReport = true;
      // let a = document.createElement("a");
      // a.href = row.url;
      // a.download = row.licenseNo+row.name+".pdf";
      // document.body.appendChild(a);
      // a.click();
      // document.body.removeChild(a);
    },
    //成绩统计
    getExperimentScoreStatics() {
      this.$api.experiment
        .getExperimentScoreStatics(this.$route.query.id)
        .then((res) => {
          this.scoreStatisticsList = res.data;
        });
    },
    hasAllScore() {
      let num = 0;
      for (const key in this.scoreStatisticsList) {
        if (!this.hasScore(this.scoreStatisticsList[key])) {
          num = num + 1;
          if (num == 4) {
            return false;
          }
        } else {
          return true;
        }
      }
    },
    hasScore(item) {
      let num = 0;
      for (let i = 0; i < item.length; i++) {
        if (item[i].count == 0) {
          num = num + 1;
          if (num == 3) {
            return false;
          }
        } else {
          return true;
        }
      }
    },
    //导出成绩
    exportScore() {
      let params = {
        id: this.$route.query.id,
        obligatory: this.active,
      };
      this.$api.experiment.exportExperimentReport(params).then((res) => {
        //照理来说是导出选中的   obligatory字段应该还需要加判断
        const blob = new Blob([res], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        util.export(blob, "成绩导出");
      });
    },
    //搜索
    search() {
      this.active = 0;
      this.getExperimentReport(0);
    },
    //获取成绩列表
    getExperimentReport(index) {
      this.searchInput = this.searchInput.trim();
      this.params.name = this.searchInput;
      this.params.obligatory = index;
      this.params.experimentId = this.$route.query.id;
      this.$api.experiment.getExperimentReport(this.params).then((res) => {
        this.scoreList = res.data.items;
        this.scoreList.forEach((item) => {
          this.$set(item, "isChioce", false);
        });
        this.totalItems = res.data.totalItems;
        this.$nextTick(() => {
          this.isLoading = true;
        });
      });
    },
    getTime(date) {
      return util.getTime(date);
    },
    toggleTab(index) {
      this.active = index;
      this.getExperimentReport(index);
    },
    handleSizeChange(val) {
      this.params.showItem = val;
      this.params.pageIndex = 1;
      this.getExperimentReport(this.active);
    },
    handleCurrentChange(val) {
      this.params.pageIndex = val;
      this.getExperimentReport(this.active);
    },
    goRouter(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="less" scoped>
.iframe-content {
  position: relative;

  .downloadBtn {
    position: absolute;
    top: -70px;
    right: 65px;
  }
}

.scoreStatistics {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: 1300px;
  width: 1300px;
}

.operation {
  cursor: pointer;
  color: #1880fa;
}

.queryResult {
  width: 100%;

  .result-container {
    padding: 22px 24px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;

    .btnList {
      display: flex;
      justify-content: start;
      align-items: center;

      .el-input {
        width: 370px;

        /deep/ .el-input__inner {
          height: 36px;
          line-height: 36px;
        }
      }

      .btn1,
      .btn2,
      .btn3 {
        width: 94px;
        height: 36px;
        background: #fff;
        border-radius: 6px;
        font-size: 14px;
        font-family: PingFang-SC;
        font-weight: 400;
        line-height: 20px;
        color: #1880fa;
        border: 1px solid #1880fa;
        box-sizing: border-box;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
      }

      .btn1 {
        background: #1880fa;
        color: #fff;
        margin: 0 18px 0 58px;
      }

      .btn3 {
        margin: 0 18px;
      }
    }

    .tabs-list {
      display: flex;
      justify-content: start;

      .list {
        margin-right: 67px;
        width: 56px;
        height: 25px;
        font-size: 14px;
        font-family: PingFang-SC;
        font-weight: 500;
        line-height: 20px;
        color: #101012;
        opacity: 1;
        cursor: pointer;
      }
    }
  }

  .content-tables {
    padding: 0 24px 55px;
    background: #fff;
    box-sizing: border-box;
  }

  /deep/ .operation {
    color: #409eff;
    text-align: center;

    i {
      font-style: normal;
      margin: 0 15px;
      color: #99a7c3;
    }

    span {
      cursor: pointer;
      font-size: 14px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 20px;
      color: #1880fa;
    }
  }

  .el-pagination {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 16px;
  }

  .el-table {
    //   padding: 24px;
    box-sizing: border-box;
    width: calc(100% - 48px);
  }

  .el-table /deep/ thead th .cell {
    color: #99a7c3;
  }

  /deep/ .el-table_1_column_6,
  .el-table_1_column_5 {
    text-align: center;
  }
}

.addExperiment-title {
  margin-bottom: 16px;

  span,
  i {
    font-size: 14px;
    font-family: PingFang-SC;
    font-weight: 400;
    line-height: 20px;
    color: #424346;
    font-style: normal;
    opacity: 1;
  }

  span {
    color: #939393;
    cursor: pointer;
  }
}

.result-active-tabs {
  border-bottom: 2px solid #1880fa;
  color: #1880fa !important;
}
</style>